import { useCallback, useEffect } from "react";
import { keyBy } from "lodash";
import { useQuery } from "@apollo/client";
import { getTeamDetail } from "src/pages/TeamDetailPage/team.graphql";
import updateLoadedData from "../utils/updateLoadedData";

const useCurrentViewTeam = ({
  loadChildTeamsById,
  dispatch,
  state,
  teamId,
}) => {
  const { data, loading } = useQuery(getTeamDetail, {
    variables: { teamId },
    errorPolicy: "all",
    skip: !teamId,
  });

  const setCurrentViewTeam = useCallback(() => {
    if (!teamId) {
      return;
    }
    const previouslyLoadedTeam = state?.loadedTeams[teamId];

    const shouldShowLoadingCard =
      loading && previouslyLoadedTeam?.isLoading !== false;

    if (shouldShowLoadingCard) {
      const newCurrentViewTeam = {
        id: teamId,
        isLoading: true,
      };

      updateLoadedData(dispatch, {
        loadedTeams: keyBy([newCurrentViewTeam], "id"),
        loadedMembers: {},
        expandedNodes: [newCurrentViewTeam.id],
        currentViewTeam: newCurrentViewTeam,
      });
    } else if (
      (state?.currentViewTeam?.isLoading && !loading) ||
      state?.currentViewTeam?.id !== teamId
    ) {
      const newCurrentViewTeam = {
        ...(data?.team || previouslyLoadedTeam),
        isLoading: false,
      };

      updateLoadedData(dispatch, {
        loadedTeams: keyBy([newCurrentViewTeam], "id"),
        loadedMembers: {},
        expandedNodes: [newCurrentViewTeam.id],
        currentViewTeam: newCurrentViewTeam,
      });

      loadChildTeamsById(newCurrentViewTeam, false);
    }
  }, [data, loading, dispatch, teamId, loadChildTeamsById, state]);

  useEffect(() => {
    setCurrentViewTeam();
  }, [setCurrentViewTeam]);
};

export default useCurrentViewTeam;
